module.exports = __webpack_public_path__ + "static/media/I.b55b9378.jpg";